<template>
  <dialog-view :open="open" title="Список платежей" big content-full-size @cancel="open=false">
    <template v-slot:content>
        <div class="py-5">
        <n-table-view
          ref="table"
          :genRequestBuilder="genRequestBuilder"
          :headers="[
          { text: 'ID', value: 'id', align: 'start', class:'text-no-wrap'},
          { text: 'Тип платежа', value: 'type', class:'text-no-wrap', sortable: false },
          { text: 'Способы расчета', value: 'source', class:'text-no-wrap', sortable: false },
          { text: 'Комментарий', value: 'comment', class:'text-no-wrap', sortable: false },
          { text: 'Кассир', value: 'operatorUser', class:'text-no-wrap', sortable: false },
          { text: 'Клиент', value: 'user', class:'text-no-wrap', sortable: false },
          { text: 'Фискальный регистратор', value: 'cashBox', class:'text-no-wrap', sortable: false },
          { text: 'Баланс личного счета', sortable: false, class:'text-no-wrap text-right'},
          { text: 'Сумма', value: 'amount', class:'text-no-wrap', sortable: false },
          { text: 'Дата', value: 'created', class:'text-no-wrap', sortable: false }
        ]"
        >
        <template v-slot:item="{item}">
          <tr @click="payId=item.id">
            <td class="text-no-wrap">{{item.id}}</td>
            <td class="text-no-wrap">
                <v-icon size="18" class="ml-n1 mr-2" :color="types[item.type].color">{{types[item.type].icon}}</v-icon>
                {{types[item.type].name}}
            </td>
            <td class="text-no-wrap">
                <pay-sources :pay="item" compact/>
            </td>
            <td class="text-no-wrap">{{item.comment}}</td>
            <td class="text-no-wrap">
                <UserFullName :user="item.operatorUser" type="spec" short/>
            </td>
            <td class="text-no-wrap">
              <UserFullName :user="item.user" short/>
            </td>
            <td class="text-no-wrap">
                <pay-devices :pay="{kktName:item.kktName}"/>
            </td>
            <td class="text-no-wrap">{{item.type==="internalIn" || item.type==="internalOut" ? '' : $tools.price(item.accountBalance)}}</td>
            <td class="text-no-wrap">{{$tools.price(item.amount)}}</td>
            <td class="text-no-wrap">{{$tools.dateTime(item.created)}}</td>
          </tr>
        </template>
      </n-table-view>
      
      <pay1 :id="payId" @cancel="payId=null"/>
      </div>
    </template>
  </dialog-view>
</template>

<script>
import State from "@/plugins/state";
import NTableView from "@/componentsV2/base/NTableView.vue";
import DialogView from "@/components/DialogView";
import PayDevices from "@/views/Pay/components/PayDevices.vue";
import PaySources from "@/views/Pay/components/PaySources.vue";
import Api from "@/Api";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";

import {
  Entity_User,
  Entity_Pay,
  Entity_VisitService,
  Entity_Visit
} from "../../../EntityStoreCacheService";


export default {
  components: {
    NTableView, PaySources, PayDevices, UserFullName,
    Pay1: () => import('@/views/Pay/Pay'),
    DialogView
  },
  props: ['visitId'],
  data: () => ({
    loadState: new State(),
    open: false,
    payId:null,
    types:Api.model.Pay.types,
  }),
  watch: {
    visitId() {
      if (this.visitId!=null){
        this.open = true;
        this.$nextTick(()=>{
          if (!this.loadState.isLoading)
            this.$refs.table.load();
        });
      }
    },
    open(){
      if(!this.open){
        this.$emit('close', null);
      }
    },
    payId(){
      if(this.payId===null)
        this.$nextTick(()=>{
            this.$refs.table.load();
        });
    }
  },
  methods:{
    genRequestBuilder(page, onPage, sortFields){
      let rb = new Entity_Pay()
      .selects(Entity_Pay.id)
      .selects(Entity_Pay.type)
      .selects(Entity_Pay.amount)
      .selects(Entity_Pay.amountPayed)
      .selects(Entity_Pay.amountCash)
      .selects(Entity_Pay.amountCard)
      .selects(Entity_Pay.amountBankAccount)
      .selects(Entity_Pay.amountAccount)
      .selects(Entity_Pay.amountOms)
      .selects(Entity_Pay.amountDms)
      .selects(Entity_Pay.amountContract)
      .selects(Entity_Pay.accountBalance)
      .selects(Entity_Pay.kktName)
      .selects(Entity_Pay.terminalName)
      .selects(Entity_Pay.tranId)
      .selects(Entity_Pay.comment)
      .selects(Entity_Pay.created)
      .selects(Entity_Pay.isAcceptBankAccount)
      .selects(Entity_Pay.isAcceptOms)
      .selects(Entity_Pay.isAcceptDms)
      .selects(Entity_Pay.isAcceptContract)

      .selects([Entity_Pay.user, Entity_User.id].join('.'))
      .selects([Entity_Pay.user, Entity_User.firstName].join('.'))
      .selects([Entity_Pay.user, Entity_User.lastName].join('.'))
      .selects([Entity_Pay.user, Entity_User.secondName].join('.'))

      .selects([Entity_Pay.operatorUser, Entity_User.id].join('.'))
      .selects([Entity_Pay.operatorUser, Entity_User.firstName].join('.'))
      .selects([Entity_Pay.operatorUser, Entity_User.lastName].join('.'))
      .selects([Entity_Pay.operatorUser, Entity_User.secondName].join('.'))

      .filterAnd([Entity_Pay.entity, Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.id].join('.') + ' =?',this.visitId)

      rb.page(page).onPage(onPage)

      sortFields.forEach(v=>{
          rb.order(v.field, v.isAsc)
      })

      rb.addStateCallback((v) => {
        this.loadState.setRequestBuilderState(v)
      })

      return rb;
    },
  }
}
</script>
